import axios from "axios";
import getAxiosConfig from "@src/utils/getAxiosConfig";
export const updateIntroVideo = async (introVideoData) => {
  try {
    const courseId = introVideoData?.courseId;
    const introVideoId = introVideoData?.introVideoId || introVideoData?.id;
    const token = localStorage.getItem("userToken");
    if (courseId && introVideoId && token) {
      await axios({
        ...getAxiosConfig(
          "POST",
          () => "/v3/course/student/intro-video-watched",
          {
            courseId,
            introVideoId,
            lastWatchedAt: new Date().toISOString(),
          },
          token
        ),
      });
    }
  } catch (err) {
    // Optionally handle error
    console.error("Failed to notify intro video watched", err);
  }
}